import { IApps, ISubmitApps } from '@/utils/interfaces'
import axios from './base'

export const getApps = (): Promise<IApps[]> => axios.get('/v2/app') 
export const myApps = (user_id: string): Promise<IApps[]> => axios.get(`/v2/users/${user_id}/apps`)
export const createApp = (payload: ISubmitApps): Promise<ISubmitApps> => axios.post(`/v2/app`, payload)
export const changeApp = (id: string, payload: ISubmitApps): Promise<ISubmitApps> => axios.put(`/v2/app/${id}`, payload)
export const updateAppPhoto = (id: string, payload: ISubmitApps): Promise<ISubmitApps> => axios.patch(`/v2/app/${id}/app_photo`, payload)
